import React, { useEffect, useRef, useState } from 'react';

const DEFAULT_GOOGLE_CLIENT_ID =
  '114921750532-qrb0l7pa48m474acknajh7vd1qj362dv.apps.googleusercontent.com';

const getGoogleClientId = () =>
  (process.env.REACT_APP_GOOGLE_CLIENT_ID || DEFAULT_GOOGLE_CLIENT_ID).replace(/\.update$/i, '').trim();

function GoogleAuthButton({ onCredential, disabled, text = 'continue_with' }) {
  const containerRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const renderButton = () => {
      if (cancelled || !containerRef.current || !window.google?.accounts?.id) {
        return false;
      }

      window.google.accounts.id.initialize({
        client_id: getGoogleClientId(),
        callback: ({ credential }) => {
          if (credential && !disabled) {
            onCredential(credential);
          }
        },
      });

      containerRef.current.innerHTML = '';
      window.google.accounts.id.renderButton(containerRef.current, {
        theme: 'outline',
        size: 'large',
        width: 320,
        text,
        shape: 'pill',
      });

      setReady(true);
      return true;
    };

    if (renderButton()) {
      return () => {
        cancelled = true;
      };
    }

    const intervalId = window.setInterval(() => {
      if (renderButton()) {
        window.clearInterval(intervalId);
      }
    }, 300);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
    };
  }, [disabled, onCredential, text]);

  return (
    <div className="google-auth-block">
      <div className="google-auth-divider">
        <span>or</span>
      </div>
      <div
        ref={containerRef}
        className={`google-auth-button ${disabled ? 'is-disabled' : ''}`}
      />
      {!ready ? <p className="google-auth-help">Loading Google sign-in...</p> : null}
    </div>
  );
}

export default GoogleAuthButton;
